import type { ColumnState } from 'ag-grid-community';
import { supabaseClient } from './supabase.js';
import { listColumnsFromGrid } from './tableListFields.js';

/**
 * Writes a table's Page Builder list layout from the grid on screen (see
 * tableListFields.ts) through public.save_table_list_layout, which checks
 * manage_default_layouts and changes only the layout's columns, order and widths.
 */
export async function saveTableListLayout(
  componentId: number,
  state: readonly ColumnState[],
  tableFields: ReadonlySet<string>,
): Promise<void> {
  const columns = listColumnsFromGrid(state, tableFields);
  if (columns.length === 0) throw new Error('Show at least one column before saving the default layout.');
  const { error } = await (supabaseClient as any).rpc('save_table_list_layout', {
    p_component_id: componentId,
    p_columns: columns,
  });
  if (error) throw new Error(error.message);
}
